module.exports = __webpack_public_path__ + "static/img/1.8a7cda85.png";